import React, { useState } from "react";
import "./EmployeeLogin.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Auth/AuthContext.js";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EMPLOYEE_API_BASE_URL } from "../Auth/Api";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const EmployeeLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);




  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading
    try {
      const response = await axios.post(`${EMPLOYEE_API_BASE_URL}/employee/login`, {
        username,
        password,
      });
      login(response.data);
      const { token, employee } = response.data; // Extract token and employee data

      // Save them in localStorage
      localStorage.setItem("authToken", token);
      localStorage.setItem("employeeData", JSON.stringify(employee));
      console.log("token", token);
      console.log("employeeData", employee)
      toast.success("Login successful! Redirecting to dashboard ...", {
        autoClose: 4000,
      });
      setTimeout(() => {
        navigate("/employee/dashboard"); // Redirect to dashboard after toast
      }, 3000);
    } catch (err) {
      setError("Invalid credentials or server error");
      toast.error("Login failed! Please check your credentials.", {
        autoClose: 3000,
      });
      console.log(error)
    } finally {
      setLoading(false); // Stop loading
    }
  };
 
  return (
    <div className="login-container">
      <ToastContainer position="top-center" />
      <div className="form-container">
        <center>

          <DotLottieReact
            src="https://lottie.host/d37ecea7-21c9-49ef-8561-ee82cfdc82cf/51kFgI2BqN.lottie"
            loop
            autoplay
          />


          {error && <p style={{ color: "red" }}>{error}</p>}
        </center>

        <form onSubmit={handleSubmit}>
          <h3 className="text-center fw-bold">EMPLOYEE LOGIN</h3>
          <div className="form-group icon-input">
            <label htmlFor="username" className="text-center fw-bold">
              Username
            </label>
            <div className="input-wrapper">
              <i className="fas fa-user icon"></i>
              <input
                type="text"
                className="form-control"
                id="username"
                name="username"
                placeholder="Enter user name"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group icon-input">
            <label htmlFor="password" className="text-center fw-bold">
              Password
            </label>
            <div className="input-wrapper">
              <i className="fas fa-lock icon"></i>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control"
                placeholder="Enter Password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i
                className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>

            <button type="submit" className="btn btn-submit" disabled={loading}>
              {loading ? (
                <span>
                  <i className="fas fa-spinner fa-spin"></i> Logging in...
                </span>
              ) : (
                "Login"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmployeeLogin;
